import { useRouteError } from 'react-router-dom';

import { IS_LOCAL } from '~/config/environment';

function ErrorPage() {
  const error = useRouteError();

  return (
    <div id='error-page'>
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      {IS_LOCAL && (
        <p>
          <i>{(error as Error)?.message || (error as { statusText?: string })?.statusText}</i>
        </p>
      )}
    </div>
  );
}

export default ErrorPage;
